export const TRANSACTIONS_PAGE_SIZE = 100

export const transactionDetailsType = [
  { value: 'Deposit', label: 'Deposit' },
  { value: 'Withdrawal', label: 'Withdrawal' },
  { value: 'Budget payment', label: 'Budget payment' },
  { value: 'Incoming int transfer', label: 'Incoming int transfer' },
  { value: 'Outgoing int transfer', label: 'Outgoing int transfer' },
  { value: 'lp_dividend', label: 'LP Dividend' },
  { value: 'dividend', label: 'Dividend' },
  { value: 'lp_investment', label: 'LP Investment' },
  { value: 'investment', label: 'Investment' },
  { value: 'earning', label: 'Earning' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'Other payment', label: 'Other payment' },
  { value: 'Reserve', label: 'In hold (reserve)' },
  { value: 'Commission', label: 'Commission' },
  { value: 'Rollback', label: 'Rollback' },
] as const

export const transactionTableColumns = [
  {
    key: 'id',
    label: 'ID CRM',
    sorter: false,
  },
  {
    key: 'psId',
    label: 'ID PS',
    sorter: false,
  },
  {
    key: 'type',
    label: 'Type',
    sorter: false,
  },
  {
    key: 'datetime',
    label: 'Date Time',
  },
  {
    key: 'amount',
    label: 'Amount',
  },
  {
    key: 'ourCommission',
    label: 'Our commission',
    sorter: false,
  },
  {
    key: 'psCommission',
    label: 'PS Commission',
    sorter: false,
  },
  {
    key: 'clientAmount',
    label: 'Client Amount',
    sorter: false,
  },
  {
    key: 'exchangeRate',
    label: 'Exchange Rate',
    sorter: false,
  },
  {
    key: 'amountUsd',
    label: 'Amount, USD',
    sorter: false,
    render: (item: string) => parseFloat(item).toString(),
  },
  {
    key: 'comment',
    label: 'Comment',
    sorter: false,
  },
  {
    key: 'action',
    label: 'Action',
    sorter: false,
  },
]

// Колонки таблицы транзакций на странице "in progress"
export const inProgressTransactionTableColumns = [
  {
    key: 'id',
    label: 'ID',
    sorter: false,
  },
  {
    key: 'type',
    label: 'Type',
    sorter: false,
  },
  {
    key: 'datetime',
    label: 'Date Time',
  },
  {
    key: 'fromWallet',
    label: 'From',
    sorter: false,
  },
  {
    key: 'amount',
    label: 'Sent Amount',
    sorter: false,
  },
  {
    key: 'ourCommission',
    label: 'Sent Commission',
    sorter: false,
  },
  {
    key: 'toWallet',
    label: 'To',
    sorter: false,
  },
  {
    key: 'clientAmount',
    label: 'Received Amount',
    sorter: false,
  },
  {
    key: 'psCommission',
    label: 'Received Commission',
    sorter: false,
  },
  {
    key: 'amountUsd',
    label: 'Amount, USD',
    sorter: false,
    render: (item: string) => parseFloat(item).toString(),
  },
  {
    key: 'comment',
    label: 'Comment',
    sorter: false,
  },
  {
    key: 'action',
    label: 'Action',
    sorter: false,
  },
]

export enum WalletStatus {
  inProgress = 'inProgress',
  general = 'general',
}
